import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import EmptyState from "@/components/base/EmptyState";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面不存在 - 看片免费app网站",
    description: "你访问的页面不存在，可以返回首页继续浏览高清影视资源与看片应用推荐。",
    keywords: "页面不存在,看片免费app网站",
  });

  return (
    <SiteLayout>
      <div className="w-full max-w-page mx-auto px-4 md:px-8 py-12">
        <EmptyState
          icon="ri-compass-3-line"
          title="这个页面不见了"
          description="链接可能已经变更，或者地址输入有误。回到首页，从焦点推荐或分类频道重新开始吧。"
          primaryLabel="返回首页"
          secondaryLabel="浏览看片APP"
          secondaryTo="/app"
        />
        <div className="flex flex-wrap items-center justify-center gap-3">
          {[
            { label: "电影频道", to: "/category/电影" },
            { label: "电视剧频道", to: "/category/电视剧" },
            { label: "综艺频道", to: "/category/综艺" },
            { label: "站内搜索", to: "/search" },
          ].map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="px-4 py-2 rounded-md border border-background-300 text-xs text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </SiteLayout>
  );
}